import {Component, Input, OnInit} from '@angular/core';
import {Button, ButtonDirective} from "primeng/button";
import {PrimeTemplate} from "primeng/api";
import {Table, TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";
import {Location, NgIf} from "@angular/common";
import {EvaluacionesService} from "../../services/evaluaciones.service";
import {AvisosObservaciones, EvaluacionEstadosControl} from "../../interfaces/evaluaciones.interface";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {NotificarSolicitudObsComponent} from "../notificar-solicitud-obs/notificar-solicitud-obs.component";
import {ProyectoItem} from "../../../../users/interfaces/proyecto.interface";

@Component({
  selector: 'app-notificaciones-evaluacion',
  standalone: true,
    imports: [
        Button,
        PrimeTemplate,
        TableModule,
        TagModule,
        TooltipModule,
        NgIf,
        NotificarSolicitudObsComponent,
    ],
  templateUrl: './notificaciones-evaluacion.component.html',
  styleUrl: './notificaciones-evaluacion.component.scss'
})
export class NotificacionesEvaluacionComponent implements OnInit{
    @Input("idSolicitud") idSolicitud: string | null = null
    @Input("idSolicitudEval") idSolicitudEval: string | null = null
    @Input("usuario") usuario: string = "";
    @Input("selected") selected: ProyectoItem | null = null;
    @Input()isVisibleButtonNtf: boolean = false;
    cols: any [] = [];
    protected readonly EvaluacionEstadosControl = EvaluacionEstadosControl;
    openDialog: boolean = false;
    infoObservacion!: AvisosObservaciones
    textReadOnlyDialog: boolean = false;

    constructor(private location: Location, protected evaluacioneService: EvaluacionesService, protected loginServices:LoginServices) {
    }
    ngOnInit(): void {
        if (this.loginServices.hasRoles(['tecnico_resolutor'])){
            this.getObtenerAvisoObservaciones(Number.parseInt(this.idSolicitud!),Number.parseInt(this.idSolicitudEval!),this.usuario,"1");
        }
        if(this.loginServices.hasRoles(['gerente','atencion.cliente'])){
            this.getObtenerAvisoObservaciones(Number.parseInt(this.idSolicitud!),Number.parseInt(this.idSolicitudEval!),this.usuario, "null");
        }
    }

  private getObtenerAvisoObservaciones(idSolicitud:number, idSolicitudEval:number, usuario:string, type:string) {
        if (this.idSolicitud != null) {
            this.evaluacioneService.obtenerAvisoObservacionesParam(idSolicitud!,idSolicitudEval!,usuario, type)
                .subscribe({
                    next: (result) => {
                        if (result && result.body) {
                            this.evaluacioneService._notificaciones.set(result.body!);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                });
        }
    }
    avisosObservacionesFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
    goBack(): void {
        this.location.back();
    }
    tagStyle(estado: boolean) {
        switch (estado) {
            case true:
                return {background: '#28a745'};
            case false:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }

    openDialogReadonlyNotificacion(notificaciones: AvisosObservaciones) {
        if(notificaciones){
            this.openDialog = true;
            this.infoObservacion = notificaciones;
            this.textReadOnlyDialog = true;
        }
    }

    openDialogNewNotificacion(notificaciones: AvisosObservaciones) {
        if(notificaciones){
            if(this.loginServices.hasRoles(['gerente'])){ // por defecto se envia 0 ya que en la pantalla de expediente no se obtiene ese valor, sin embargo la consulta tiene el id de evaluacion
                if (this.idSolicitudEval === "0"){
                    this.idSolicitudEval = String(notificaciones.idSolicitudEval);
                }
            }
            this.openDialog = true;
            this.infoObservacion = notificaciones;
            this.textReadOnlyDialog = false;
        }
    }

    onDialogClosed(event: boolean) {
        this.openDialog = event;
    }


}
